import { clientRPC } from '@/utils/hono-client';

/**
 * Tell the server the error page was shown. Best-effort, and it never THROWS.
 *
 * Its caller is the error page's effect, and that page is rendered by the
 * boundary that caught the crash — a boundary that catches its own fallback's
 * errors too. A throw here re-rendered the page with a new `error`, re-ran the
 * effect and threw again, until React's nested-update limit (FLASHKA-VITE-2SJ
 * / -2QN, Chrome 91 and iOS 14–15). The hono client throws SYNCHRONOUSLY on an
 * engine without `Array.prototype.at` (its proxy calls `parts.at(-1)` before
 * any fetch), so a `.catch` on the promise alone never saw it.
 */
export function postErrorWarning(error: string): void {
  try {
    clientRPC.api['error-warning'].$post({ json: { error } }).catch(console.error);
  } catch (reportError) {
    console.error(reportError);
  }
}
